module.exports = __webpack_public_path__ + "static/igor-497a2e9f2c62cf5b589c69c69616f1db.png";